import { Component, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'pn-proxio-productcard',
  styleUrl: 'pn-proxio-productcard.scss',
})
export class PnProxioProductcard {
  render() {
    return (
      <Host>
        <div class="cardcontent">
          <div class="carddetails">
            <slot name="illustrationmobile" />
            <div class="heading">
              <slot name="title" />
              <slot name="uppertags" />
            </div>
            <slot name="description" />
            <slot name="information" />
            <slot name="bottomtags" />
          </div>
          <div class="cardcalltoactions">
            <slot name="illustration" />
            <slot name="pricelink" />
            <slot name="insurance" />
          </div>
        </div>
      </Host>
    );
  }
}
